"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.freighterHandler = void 0;
var freighter_api_1 = __importDefault(require("@stellar/freighter-api"));
var stellar_sdk_1 = require("@stellar/stellar-sdk");
var Types_1 = require("../Types");
exports.freighterHandler = {
    keyType: Types_1.KeyType.freighter,
    signTransaction: function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, key, custom, networkPassphrase, response, _a, message, code, error_1, errorMsg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        transaction = params.transaction, key = params.key, custom = params.custom;
                        if (key.privateKey !== "") {
                            throw new Error("Non-Freighter key sent to Freighter handler: ".concat(key.publicKey));
                        }
                        networkPassphrase = (custom && custom.networkPassphrase) || key.network || stellar_sdk_1.Networks.PUBLIC;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, freighter_api_1.default.signTransaction(transaction.toXdr(), {
                                networkPassphrase: networkPassphrase,
                                address: custom && custom.address ? custom.address : undefined,
                            })];
                    case 2:
                        response = _b.sent();
                        if (response.error) {
                            _a = response.error, message = _a.message, code = _a.code;
                            throw new Error(message
                                ? "Freighter signTransaction failed: ".concat(message, " (code ").concat(code, ")")
                                : "Freighter signTransaction failed with code ".concat(code));
                        }
                        // fromXdr() returns type "Transaction | FeeBumpTransaction" and
                        // signTransaction() doesn't like "| FeeBumpTransaction" type, so casting
                        // to "Transaction" type.
                        return [2 /*return*/, stellar_sdk_1.TransactionBuilder.fromXdr(response.signedTxXdr, networkPassphrase)];
                    case 3:
                        error_1 = _b.sent();
                        if (error_1 instanceof Error) {
                            throw error_1;
                        }
                        errorMsg = String(error_1);
                        throw new Error("We couldn't sign the transaction with Freighter. ".concat(errorMsg, "."));
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
};
